import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import Modal from "react-modal";
import Cross from "../../../Theming/icons/Cross/index";
import "./index.css";
const ModalPanel = props => {
  const [scrollPosition, setScrollPosition] = useState(0);
  Modal.setAppElement("#root");
  const afterOpen = () => {
    const $body = document.querySelector("body");
    const pageYOffset = window.pageYOffset;
    setScrollPosition(pageYOffset);
    $body.style.overflow = "hidden";
    $body.style.position = "fixed";
    $body.style.top = `-${pageYOffset}px`;
    $body.style.width = "100%";
  };
  const afterClose = () => {
    const $body = document.querySelector("body");
    $body.style.removeProperty("overflow");
    $body.style.removeProperty("position");
    $body.style.removeProperty("top");
    $body.style.removeProperty("width");
    window.scrollTo(0, scrollPosition);
    if (props.afterClose) {
      props.afterClose();
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    isOpen: props.isOpen,
    onRequestClose: props.onRequestClose,
    contentLabel: props.contentLabel,
    className: {
      base: `modal__content ${props.contentClassName || ""} ${props.gtmClassName || ""}`,
      afterOpen: "modal__content--open",
      beforeClose: "modal__content--close"
    },
    overlayClassName: {
      base: `modal__overlay ${props.overlayClassName || ""}`,
      afterOpen: "modal__overlay--open",
      beforeClose: "modal__overlay--close"
    },
    closeTimeoutMS: typeof props.closeTimeoutMS !== "undefined" ? props.closeTimeoutMS : 500,
    onAfterOpen: afterOpen,
    onAfterClose: afterClose
  }, props.children, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: `icon-btn ${props.closeClassName || ""}`,
    "aria-label": props.t("Close"),
    onClick: props.onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "icon-btn__inner"
  }, /*#__PURE__*/React.createElement(Cross, {
    className: "icon-btn__svg"
  })))));
};
const ModalPanelWithTranslation = withTranslation()(ModalPanel);
export default ModalPanelWithTranslation;